import { render, staticRenderFns } from "./HeaderLangSelector.vue?vue&type=template&id=8b04d0b0"
import script from "./HeaderLangSelector.vue?vue&type=script&lang=js"
export * from "./HeaderLangSelector.vue?vue&type=script&lang=js"
import style0 from "./HeaderLangSelector.vue?vue&type=style&index=0&id=8b04d0b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports